<template>
  <ContentWrapperControl>
    <SettingCardControl v-bind:title="lang('lbl_0000078')" class="mt-4">
      <SettingCardItemControl
        v-bind:value="username"
        v-bind:title="lang('lbl_0000041')"
        icon="papsi_setting_username.svg"
        href="/settings/username"
      />
      <SettingCardItemControl
        v-bind:value="password"
        v-bind:title="lang('lbl_0000042')"
        icon="papsi_setting_password.svg"
        href="/settings/password"
      />
      <SettingCardItemControl
        v-bind:title="lang('lbl_0000081')"
        icon="papsi_memdata.svg"
        href="/settings/info"
        :show_border="false"
      />
    </SettingCardControl>
    <SettingCardControl v-bind:title="lang('lbl_0000079')">
      <SettingCardItemControl
        v-bind:value="mobile"
        v-bind:title="lang('lbl_0000021')"
        icon="papsi_setting_mobile.svg"
        href="/settings/mobile"
      />
      <SettingCardItemControl
        v-bind:value="email"
        v-bind:title="lang('lbl_0000022')"
        icon="papsi_setting_email.svg"
        href="/settings/email"
        :show_border="false"
      />
    </SettingCardControl>
    <SettingCardControl v-bind:title="lang('lbl_0000080')">
      <SettingCardItemControl
        v-bind:title="lang('lbl_0000032')"
        icon="papsi_pin.svg"
        href="/settings/security/pin"
      />
      <SettingCardItemControl
        v-bind:title="lang('lbl_0000082')"
        icon="papsi_setting_auth.svg"
        href="/settings/security/authentication"
      />
      <SettingCardItemControl
        v-bind:title="lang('lbl_0000069')"
        icon="papsi_setting_deactivate.svg"
        href="/settings/deactivate"
        :show_border="false"
      />
    </SettingCardControl>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import SettingCardControl from "./../../components/controls/SettingCardControl.vue";
import SettingCardItemControl from "./../../components/controls/SettingCardItemControl.vue";
import parseMobile from "libphonenumber-js";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    SettingCardControl,
    SettingCardItemControl,
  },
  data() {
    return {
      username: "",
      password: "",
      mobile: "",
      email: "",
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", false);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000085"),
      show: true,
      back: true,
    });

    let state = this.$store.state;

    this.username = state.info.username;
    this.password = state.password;
    this.email = state.info.email;

    if (state.info.mobile_no != null) {
      let mobile = parseMobile(state.info.mobile_no, "PH")
        .formatNational()
        .split(" ");

      this.mobile = "(" + mobile[0] + ") " + mobile[1] + " " + mobile[2];
    }
  },
};
</script>
